import React, { useEffect, useMemo, useState } from 'react';
import exportRowsToCsv from "../../../Components/Common/DashboardKit/exportCsv";
import TableContainer from "../../../Components/Common/TableContainerReactTable";
import TableContainerUser from "../../../Components/Common/TableContainerReactTableUser";
import { Link } from 'react-router-dom';
import api from "../../../api"
import { assetUrl } from "../../../utils/assetBase"; // HR Round 5 / Issue 8
import FeatherIcon from "feather-icons-react";
import { Alert, Card, CardBody, Modal, ModalHeader, Container, ModalBody, ModalFooter, Button, Toast, ToastBody, Table, Spinner } from 'reactstrap';
import { CardHeader, Col, Form, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from "classnames";
import DmsViewModal from '../../DocumentManagementSystem/ECN/DmsViewModal';
import { refreshStoredDmsPdf } from '../../DocumentManagementSystem/utils/dmsToPdf';   // Go-live parity (2026-09-24): DMS stored PDF follows status changes
import logoLight from "../../../assets/images/logofinal.png";
import progileBg from '../../../assets/images/profile-bg.jpg';
import { ToastContainer, toast } from 'react-toastify';
import Flatpickr from "react-flatpickr";
import { useNavigate } from 'react-router-dom';
import EpoViewModal from "../../ExpensePurchaseOrder/EpoViewModal";
import { downloadEpoPdf } from '../../../../src/pages/ExpensePurchaseOrder/epoToPdf';
const DefaultTable = () => {
  const defaultTable =
    [
      { id: "10", name: "Tyrone", email: "tyrone@example.com", designation: "Senior Response Liaison", company: "Raynor, Rolfson and Daugherty", location: "Qatar" },
      { id: "09", name: "Cathy", email: "cathy@example.com", designation: "Customer Data Director", company: "Ebert, Schamberger and Johnston", location: "Mexico" },
      { id: "08", name: "Patsy", email: "patsy@example.com", designation: "Dynamic Assurance Director", company: "Streich Group", location: "Niue" },
      { id: "07", name: "Kerry", email: "kerry@example.com", designation: "Lead Applications Associate", company: "Feeney, Langworth and Tremblay", location: "Niger" },
      { id: "06", name: "Traci", email: "traci@example.com", designation: "Corporate Identity Director", company: "Koelpin - Goldner", location: "Vanuatu" },
      { id: "05", name: "Noel", email: "noel@example.com", designation: "Customer Data Director", company: "Howell - Rippin", location: "Germany" },
      { id: "04", name: "Robert", email: "robert@example.com", designation: "Product Accounts Technician", company: "Hoeger", location: "San Marino" },
      { id: "03", name: "Shannon", email: "shannon@example.com", designation: "Legacy Functionality Associate", company: "Zemlak Group", location: "South Georgia" },
      { id: "02", name: "Harold", email: "harold@example.com", designation: "Forward Creative Coordinator", company: "Metz Inc", location: "Iran" },
      { id: "01", name: "Jonathan", email: "jonathan@example.com", designation: "Senior Implementation Architect", company: "Hauck Inc", location: "Holy See" }
    ]
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: (cellProps) => {
          return (
            <span className="fw-semibold">{cellProps.id}</span>
          )
        },
        disableFilters: true,
        filterable: false,
      },

      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Designation",
        accessor: "designation",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Company",
        accessor: "company",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Location",
        accessor: "location",
        disableFilters: true,
        filterable: false,
      }
    ],
    []
  );

  return (
    <React.Fragment>
      <TableContainer
        columns={(columns || [])}
        data={(defaultTable || [])}
        isPagination={false}
        // isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={5}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search...'
      />

    </React.Fragment>
  );
};

const PaginationTable = () => {
  const paginationTable =
    [{ id: "#VL2111", name: "Jonathan", date: "07 Oct, 2021", total: "$24.05", status: "Paid" },
    { id: "#VL2110", name: "Harold", date: "07 Oct, 2021", total: "$26.15", status: "Paid" },
    { id: "#VL2109", name: "Shannon", date: "06 Oct, 2021", total: "$21.25", status: "Refund" },
    { id: "#VL2108", name: "Robert", date: "05 Oct, 2021", total: "$25.03", status: "Paid" },
    { id: "#VL2107", name: "Noel", date: "05 Oct, 2021", total: "$22.61", status: "Paid" },
    { id: "#VL2106", name: "Traci", date: "04 Oct, 2021", total: "$24.05", status: "Paid" },
    { id: "#VL2105", name: "Kerry", date: "04 Oct, 2021", total: "$26.15", status: "Paid" },
    { id: "#VL2104", name: "Patsy", date: "04 Oct, 2021", total: "$21.25", status: "Refund" },
    { id: "#VL2103", name: "Cathy", date: "03 Oct, 2021", total: "$22.61", status: "Paid" },
    { id: "#VL2102", name: "Tyrone", date: "03 Oct, 2021", total: "$25.03", status: "Paid" }]

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: (cellProps) => {
          return (
            <Link to="#" className="fw-medium">{cellProps.id}</Link>
          )
        },
        disableFilters: true,
        filterable: false,
      },

      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Total",
        accessor: "total",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          switch (cellProps.status) {
            case "Paid":
              return (<span className="badge badge-soft-success text-uppercase"> {cellProps.status}</span>)
            case "Refund":
              return (<span className="badge badge-soft-warning text-uppercase"> {cellProps.status}</span>)
            default:
              return (<span className="badge badge-soft-danger text-uppercase"> {cellProps.status}</span>)
          }
        },
      },
      {
        Header: "Actions",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          return (
            <React.Fragment>
              Details
            </React.Fragment>
          )
        },
      },
    ],
    []
  );

  return (
    <React.Fragment >
      <TableContainer
        columns={(columns || [])}
        data={(paginationTable || [])}
        isPagination={true}
        // isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={5}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search Products...'
      />
    </React.Fragment >
  );
};

const SearchTable = ({ data }) => {
  const [viewEmployee, setViewEmployee] = useState({});
  const [activeTab, setActiveTab] = useState("1");

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [searchTable, setSearchTable] = useState(data);




  useEffect(() => {
    setSearchTable(data);  // Update state when data prop changes
  }, [data]);

  const columns = useMemo(
    () => [
      {
        Header: "Emp ID",
        accessor: (cellProps) => {
          return (
            <span className="fw-semibold">{cellProps.empId}</span>
          )
        },
        disableFilters: true,
        filterable: false,
      },

      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => {
          // Apply badge with class based on status
          const badgeClass = value === "IN" ? "bg-success" : "bg-danger";
          return <span className={`badge ${badgeClass}`}>{value}</span>;
        },
      },
      {
        Header: "ReturningAt",
        accessor: "returningAt",
        disableFilters: true,
        filterable: false,
      }

    ],
    []
  );



  return (
    <React.Fragment >
      <TableContainer
        columns={(columns || [])}
        data={(searchTable || [])}
        isPagination={true}
        isGlobalFilter={true}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={10}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search...'

      />

    </React.Fragment >
  );
};

const SearchTableEdit = ({ data }) => {
  const [viewEmployee, setViewEmployee] = useState({});
  const [activeTab, setActiveTab] = useState("1");

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await api.get("registration/departments");
        setDepartments(res.data);
      } catch (err) {
        console.error("Failed to fetch departments:", err);
      }
    };

    fetchDepartments();
  }, []);

  const [supervisorName, setSupervisorName] = useState("");

  // Round HR-PA UI batch (2026-08-18): the view modal showed the raw
  // supervisor EmpID; resolve it to a name from the supervisors lookup the
  // registration form already uses.
  const [supervisors, setSupervisors] = useState([]);
  const [rolesList, setRolesList] = useState([]);   // Round 2j
  useEffect(() => {
    api.get("registration/roles")   // Round 2j: Role editable in the modal
      .then((r) => setRolesList(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
    api.get("registration/supervisors")
      .then((r) => setSupervisors(Array.isArray(r.data) ? r.data : []))
      .catch(() => setSupervisors([]));
  }, []);
  const supDisplay = (id) => {
    if (id === null || id === undefined || id === "") return "";
    const hit = supervisors.find((x) => String(x.empID ?? x.empId) === String(id).trim());
    return hit ? `${hit.name} (${id})` : String(id);
  };

  // useEffect(() => {
  //   const fetchSupervisor = async () => {
  //     if (viewEmployee.supervisor) {
  //       try {
  //         const res = await api.get(`registration/supervisor-name/${viewEmployee.supervisor}`);
  //         setSupervisorName(res.data);
  //         console.log("Supervisor Name :", res.data);
  //       } catch (err) {
  //         console.error("Failed to fetch supervisor name:", err);
  //       }
  //     }
  //   };

  //   fetchSupervisor();
  // }, [viewEmployee.supervisor]);
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [searchTable, setSearchTable] = useState(data);
  const [modal_togView, setmodal_togView] = useState('');
  const [empID, setEmpID] = useState(null);
  const [modal_togFirst, setmodal_togFirst] = useState('');
  const [modal_togSecond, setmodal_togSecond] = useState('');
  const [modal_togDelete, setmodal_togDelete] = useState('');
  const [modal_togDeleteSecond, setmodal_togDeleteSecond] = useState('');
  const [editEmployee, setEditEmployee] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  function tog_togView() {
    setmodal_togView(!modal_togView);

    if (modal_togView) {
      setIsEditMode(false);
      setEditEmployee({});
      setViewEmployee({});
    }


  }

  function tog_togFirst() {
    setmodal_togFirst(!modal_togFirst)
  }

  function tog_togSecond() {
    setmodal_togSecond(!modal_togSecond)
  }
  function tog_togDelete() {
    setmodal_togDelete(!modal_togDelete)
  }

  function tog_togDeleteSecond() {
    setmodal_togDeleteSecond(!modal_togDeleteSecond)
  }

  const getImagePath = () => {
    // HR Round 5 / Issue 8 — consistent avatar host: use the shared assetUrl
    // helper (env-driven, Round TA-4) instead of a hardcoded server name, so
    // this modal, the top bar, and My Profile all resolve images identically.
    const imagePath = (editEmployee?.imagePath || viewEmployee?.imagePath || "").trim();
    return assetUrl(imagePath || undefined);
  };

  const handleView = async (empId) => {
    try {
      const response = await api.get(`registration/get-employee/${empId}`);

      if (response.status === 200) {
        setViewEmployee(response.data);
        tog_togView()
      }
    } catch (error) {
      // HR-UAT-8: surface a controlled message instead of failing silently
      // (previously a 500/403 here left HR staring at a dead eye icon).
      console.error("Error fetching employee:", error);
      toast.error(error?.response?.data?.message || "Unable to load this employee. Please try again.");
    }
  };


  const handleEdit = async (empId) => {
    try {
      const response = await api.get(`registration/get-employee/${empId}`);
      if (response.status === 200) {
        setEditEmployee(response.data);
        setFormData({ ...response.data });
        setEmpID(empId);
        setIsEditMode(true);
        tog_togView();
      }
    } catch (err) {
      // HR-UAT-8: controlled toast — see handleView above.
      console.error("Failed to load employee:", err);
      toast.error(err?.response?.data?.message || "Unable to load this employee for editing. Please try again.");
    }
  };

  const getDepartmentName = (id) => {
    const dept = departments.find((d) => d.id === viewEmployee.dept);
    return dept ? dept.description : viewEmployee.dept;
  };

  const handleDelete = async (empId) => {
    tog_togDelete()
  };


  //Update Employee

  const [formData, setFormData] = useState({
    EmpID: 0,

    FirstName: "",
    MI: "",
    LastName: "",
    Street1: "",
    Street2: "",
    City: "",
    State: "",
    Zip: "",
    Country: "",
    Phone: "",
    dob: "",
    EmgContact: "",
    EpoLimit: 0,
    HireDate: "",
    Grade: 0,
    Type: "",
    Rate: 0.0,
    EmpStatus: "",
    ExpenseCode: "",
    Shift: 1,
    Supervisor: "",
    Dept: "",
    Extension: "",
    Email: "",
    WindowsID: "",
    Title: "",
    CompanyCell: "",
    Gender: "",
    password: "",
    FtoOffset: 0,
    RoleId: 0,
    Temporary: false,   // Round 3 (G-42)
  });



  // HR Round 5 / Issue 7 — add/replace the photo of an EXISTING employee.
  // add-employee accepted a photo at creation, but nothing could set one
  // afterwards (the HR dashboard's "Missing photos" count had no fix path).
  // Posts multipart to the new HR-gated /registration/employee-photo, then
  // reflects the returned path immediately in the open modal.
  const handleEditPhotoChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Please choose an image file.'); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error('Image is too large — maximum size is 5 MB.'); return; }
    const empId = editEmployee?.empID;
    if (!empId) { toast.error('No employee loaded.'); return; }
    try {
      const fd = new FormData();
      fd.append('empId', empId);
      fd.append('profileImage', file);
      const r = await api.post('registration/employee-photo', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const newPath = r.data?.imagePath;
      if (newPath) {
        setEditEmployee(prev => ({ ...prev, imagePath: newPath }));
        toast.success('Profile photo updated.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Photo upload failed.');
    }
  };

  const handleUpdateEmployee = async () => {
    try {
      const payload = {
        ...formData,

      };
      console.log("Submitting payload: ", JSON.stringify(payload, null, 2));
      const response = await api.put(
        `registration/update-employee`,
        payload
      );

      if (response.status === 200) {
        if (response.data?.warning) {
          toast.warning(response.data.warning, { autoClose: 8000 });
        } else {
          toast.success(response.data?.message || "Employee details updated successfully!");
        }
        tog_togSecond();
        tog_togFirst(false);
      } else {
        toast.error("Failed to update employee.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("An error occurred while updating.");
    }
  };
  //Update Employee


  //Inactive Employee
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const handleInactiveEmployee = async () => {
    try {


      const response = await api.put(
        `registration/set-inactive`, {
        EmpID: selectedEmpId
      }

      );

      if (response.status === 200) {
        if (response.data?.warning) {
          toast.warning(response.data.warning, { autoClose: 8000 });
        } else {
          toast.success(response.data?.message || "Employee inactivated successfully!");
        }
        tog_togDeleteSecond();
        tog_togDelete(false);
      } else {
        toast.error("Failed to inactive employee.");
      }
    } catch (error) {
      console.error("Inactive error:", error);
      toast.error("An error occurred while Inactivating.");
    }
  };
  //Inactive Employee end
  useEffect(() => {
    setSearchTable(data);  // Update state when data prop changes
  }, [data]);

  const columns = useMemo(
    () => [
      {
        Header: "Emp ID",
        accessor: "empId",
        // HR-UAT-3 rev.2 follow-up (2026-08-24): header-click sorting is
        // disabled on this table. The container wires getSortByToggleProps
        // onto every <th>, so a single (easy, accidental) click on a header
        // silently re-sorted the roster client-side — e.g. "Emp ID" ascending
        // — overriding the mandated latest-record-created server order.
        // Column FILTERS are unaffected and retained.
        disableSortBy: true,
        disableFilters: false,
        className: "text-center",
        filterable: true,
      },

      // Round HR-PA UI batch (2026-08-18): owner asked for column-wise
      // filters — the container already renders a per-column filter row for
      // any column with canFilter, so these columns simply opt in.
      {
        Header: "Name",
        accessor: "name",
        disableSortBy: true,
        disableFilters: false,
        filterable: true,
      },
      {
        Header: "Designation",
        accessor: "title",
        disableSortBy: true,
        disableFilters: false,
        filterable: true,
      },
      {
        Header: "Emp. Status",
        accessor: "status",
        disableSortBy: true,
        disableFilters: false,
        filterable: true,

      },
      {
        Header: "Supervisor",
        accessor: "supervisor",
        disableSortBy: true,
        disableFilters: false,
        filterable: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableSortBy: true,
        className: "text-center",
        Cell: ({ row }) => (
          <div className="hstack gap-3 fs-15">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault(); // prevent page jump
                handleView(row.original.empId);
              }}
              className="link-info"
              title="View"
            >
              <i className="ri-eye-line"></i>
            </Link>

            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault(); // prevent page jump
                handleEdit(row.original.empId);
              }}
              className="link-primary"
              title="Edit"
            >
              <i className="ri-pencil-fill align-bottom" />
            </Link>

            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedEmpId(row.original.empId);
                tog_togDelete();
              }}
              className="link-danger"
              title="Inactive"
            >
              <i className="ri-delete-bin-5-line"></i>
            </Link>
          </div>
        ),
      }



    ],
    []
  );
  return (
    <React.Fragment >
      <TableContainerUser
        columns={(columns || [])}
        data={(searchTable || [])}
        isPagination={true}
        /* Owner request (2026-08-24, UAT pass 2): global "Search User…" box
           removed from Manage Employee — per-column filters are the search.
           Container + prop untouched, so every other table keeps its box. */
        isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={10}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search User...'

      />

      <Modal size="xl" isOpen={modal_togView} toggle={tog_togView}>
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-5'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
              {/* <button className="btn btn-light"><i className="ri-google-fill align-bottom text-danger"></i> Google</button>
              <button className="btn btn-info"><i className="ri-facebook-fill align-bottom"></i> Facebook</button> */}
            </div>
          </ModalBody>
          <ModalBody>
            <Container fluid>
              {/* <div className="position-relative mx-n4 mt-n4">
                <div className="profile-wid-bg profile-setting-img">
                  <img src={progileBg} className="profile-wid-img" alt="" />
                  <div className="overlay-content">
                    <div className="text-end p-3">
                      <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                        <Input id="profile-foreground-img-file-input" type="file"
                          className="profile-foreground-img-file-input" />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <Row>
                <Col xxl={3}>
                  <Card className="mt-n5">
                    <CardBody className="p-4">
                      <div className="card ribbon-box border shadow-none mb-lg-0">
                        <div className="card-body text-center">
                          <div className="ribbon-two ribbon-two-primary">
                            {isEditMode ? (
                              <span>
                                {editEmployee.empID || "Emp.ID"}
                              </span>
                            ) : (
                              <span>
                                {viewEmployee.empID || "Emp.ID"}
                              </span>
                            )}
                          </div>
                          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                            <img src={getImagePath()}
                              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                              alt="user-profile" />
                          </div>
                          {/* HR Round 5 / Issue 7 — photo add/replace for an existing employee */}
                          {isEditMode && (
                            <div className="mb-2">
                              <label className="btn btn-sm btn-soft-primary mb-0">
                                <i className="ri-camera-line align-bottom me-1" />
                                Change photo
                                <input type="file" accept="image/*" hidden
                                  onChange={handleEditPhotoChange} />
                              </label>
                            </div>
                          )}
                          {isEditMode ? (
                            <div>
                              <h5 className="fs-16 mb-1">{editEmployee.firstName} {editEmployee.lastName}</h5>
                              <p className="text-muted mb-0">{editEmployee.title}</p>
                            </div>
                          ) : (
                            <div>
                              <h5 className="fs-16 mb-1">{viewEmployee.firstName} {viewEmployee.lastName}</h5>
                              <p className="text-muted mb-0">{viewEmployee.title}</p>
                            </div>
                          )}

                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xxl={9}>
                  <Card className="mt-xxl-n5">
                    <CardHeader>
                      <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                        role="tablist">
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                              tabChange("1");
                            }}>
                            <i className="fas fa-home"></i>
                            Personal Details
                          </NavLink>
                        </NavItem>

                      </Nav>
                    </CardHeader>
                    <CardBody className="p-4">
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                          <Form>
                            {/* Round 2k (owner): modal body rebuilt into the Add-form order —
    Personal → Address & Contact → Employment — every field block is
    the previous one verbatim (handlers untouched), only position and
    column sizing changed. */}
<div className="text-muted text-uppercase small fw-semibold mt-3 mb-1" style={{ letterSpacing: ".04em" }}>Personal information</div>
<Row className="g-3 mt-0"><Col lg={3}>
                                <Label>Role</Label>
                                {/* Access-Management hardening (Round 1, decision D5): the HR
                                    form no longer assigns roles (the API ignores roleId on
                                    update-employee). Roles are managed in Admin → Access
                                    Management → Employee Role Assignment. Read-only here. */}
                                <Input type="text" value={viewEmployee.roleName || "No role assigned"} readOnly />
                                {isEditMode && (
                                  <div className="form-text">Roles are assigned in Access Management, not here.</div>
                                )}
                              </Col><Col lg={3}>
                                <Label>Firstname</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.firstName ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, firstName: value });
                                      setFormData({ ...formData, firstName: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.firstName || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={2}>
                                <Label>Middle Initial</Label>
                                {isEditMode ? (
                                  <Input type="text" maxLength={1}
                                    value={editEmployee.mi ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, mi: value });
                                      setFormData({ ...formData, mi: value });
                                    }} />
                                ) : (
                                  <Input type="text" value={viewEmployee.mi || "N/A"} readOnly />
                                )}
                              </Col><Col lg={4}>
                                <Label>Lastname</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.lastName ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, lastName: value });
                                      setFormData({ ...formData, lastName: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.lastName || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col></Row>
<Row className="g-3 mt-0"><Col lg={4}>
                                <Label>D.O.B</Label>
                                {isEditMode ? (
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Select date"
                                    value={editEmployee.dateofbirth ? new Date(editEmployee.dateofbirth) : ""}
                                    onChange={(_, dateStr) => {
                                      // binds DTO.dob (nullable since Round 2h) —
                                      // date-only LOCAL string, blank = keep stored.
                                      setEditEmployee({ ...editEmployee, dateofbirth: dateStr || "" });
                                      setFormData({ ...formData, dob: dateStr || "" });
                                    }}
                                    options={{ dateFormat: "Y-m-d", maxDate: "today" }}
                                  />
                                ) : (
                                  <Input type="text" readOnly
                                    value={viewEmployee.dateofbirth
                                      ? new Date(viewEmployee.dateofbirth).toLocaleDateString()
                                      : "N/A"} />
                                )}
                              </Col><Col lg={4}>
                                <Label>Title</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.title ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, title: value });
                                      setFormData({ ...formData, title: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.title || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Email Address</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.email ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, email: value });
                                      setFormData({ ...formData, email: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.email ?? "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col></Row>
<div className="text-muted text-uppercase small fw-semibold mt-3 mb-1" style={{ letterSpacing: ".04em" }}>Address & contact</div>
<Row className="g-3 mt-0"><Col lg={6}>
                                <Label>Street Address 1</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.street1 ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, street1: value });
                                      setFormData({ ...formData, street1: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.street1 || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={6}>
                                <Label>Street Address 2</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.street2 ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, street2: value });
                                      setFormData({ ...formData, street2: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.street2 || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col></Row>
<Row className="g-3 mt-0"><Col lg={3}>
                                <Label>City</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.city ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, city: value });
                                      setFormData({ ...formData, city: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.city || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={3}>
                                <Label>State</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.state ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, state: value });
                                      setFormData({ ...formData, state: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.state || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={3}>
                                <Label>ZIP</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.zip ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, zip: value });
                                      setFormData({ ...formData, zip: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.zip || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={3}>
                                <Label>Country</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.country ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, country: value });
                                      setFormData({ ...formData, country: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.country || "USA"}
                                    readOnly
                                  />
                                )}
                              </Col></Row>
<Row className="g-3 mt-0"><Col lg={4}>
                                <Label>Phone</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.phone ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, phone: value });
                                      setFormData({ ...formData, phone: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.phone || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Emergency Contact Name</Label>
                                {isEditMode ? (
                                  <Input type="text"
                                    value={editEmployee.emgContact ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, emgContact: value });
                                      setFormData({ ...formData, emgContact: value });
                                    }} />
                                ) : (
                                  <Input type="text" value={viewEmployee.emgContact || "N/A"} readOnly />
                                )}
                              </Col><Col lg={4}>
                                <Label>Emergency Phone</Label>
                                {isEditMode ? (
                                  <Input type="text"
                                    value={editEmployee.emgPhone ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, emgPhone: value });
                                      setFormData({ ...formData, emgPhone: value });
                                    }} />
                                ) : (
                                  <Input type="text" value={viewEmployee.emgPhone || "N/A"} readOnly />
                                )}
                              </Col></Row>
<div className="text-muted text-uppercase small fw-semibold mt-3 mb-1" style={{ letterSpacing: ".04em" }}>Employment</div>
<Row className="g-3 mt-0"><Col lg={4}>
                                <Label>Rate Type</Label>
                                {isEditMode ? (
                                  /* UAT pass 6: free-text Rate Type replaced by a
                                     select. Typing "Salary" here used to store the
                                     literal word into empbasic.expensecode; the
                                     select stores the real codes (IDL / DL). */
                                  <Input
                                    type="select"
                                    value={
                                      editEmployee.expenseCode === "IDL"
                                        ? "IDL"
                                        : editEmployee.expenseCode
                                          ? "DL"
                                          : ""
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, expenseCode: value });
                                      setFormData({ ...formData, expenseCode: value });
                                    }}
                                  >
                                    <option value="">Select rate type</option>
                                    <option value="IDL">Salary</option>
                                    <option value="DL">Hourly</option>
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    value={
                                      viewEmployee.expenseCode === "IDL"
                                        ? "Salary"
                                        : viewEmployee.expenseCode
                                          ? "Hourly"
                                          : ""
                                    }
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Department</Label>
                                {isEditMode ? (
                                  <Input
                                    type="select"
                                    value={editEmployee.dept ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, dept: value });
                                      setFormData({ ...formData, dept: value });
                                    }}
                                  >
                                    <option value="">Select Department</option>
                                    {departments.map((d) => (
                                      <option key={d.id} value={d.id}>
                                        {d.description}
                                      </option>
                                    ))}
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    value={getDepartmentName(viewEmployee.dept) ?? "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Supervisor</Label>
                                {isEditMode ? (
                                  /* UAT pass 6 (owner): supervisor edits by NAME —
                                     a dropdown of the same active-supervisor list
                                     the Add-Employee form uses (registration/
                                     supervisors), instead of a raw-EmpID text box.
                                     The stored ID is trimmed so padded legacy
                                     values still match their option; picking a new
                                     supervisor stores that supervisor's EmpID. */
                                  <Input
                                    type="select"
                                    value={String(editEmployee.supervisor ?? "").trim()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, supervisor: value });
                                      setFormData({ ...formData, supervisor: value });
                                    }}
                                  >
                                    <option value="">Select supervisor</option>
                                    {supervisors.map((s) => (
                                      <option key={s.empID ?? s.empId} value={s.empID ?? s.empId}>
                                        {s.name} ({s.empID ?? s.empId})
                                      </option>
                                    ))}
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    value={supDisplay(viewEmployee.supervisor) || supervisorName}
                                    readOnly
                                  />
                                )}
                              </Col></Row>
<Row className="g-3 mt-0"><Col lg={4}>
                                <Label>Hire Date</Label>
                                {isEditMode ? (
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Select date"
                                    value={editEmployee.hireDate ? new Date(editEmployee.hireDate) : ""}
                                    onChange={(_, dateStr) => {
                                      setEditEmployee({ ...editEmployee, hireDate: dateStr || "" });
                                      setFormData({ ...formData, hireDate: dateStr || "" });
                                    }}
                                    options={{
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={
                                      viewEmployee.hireDate
                                        ? new Date(viewEmployee.hireDate).toLocaleDateString()
                                        : "N/A"
                                    }
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Employee Status</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.empStatus ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, empStatus: value });
                                      setFormData({ ...formData, empStatus: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.empStatus || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col><Col lg={4}>
                                <Label>Temporary / Intern Employee</Label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 8 }}>
                                  <Input
                                    type="checkbox"
                                    style={{ width: 18, height: 18 }}
                                    disabled={!isEditMode}
                                    checked={
                                      isEditMode
                                        ? !!(editEmployee.temporary ?? formData.Temporary)
                                        : !!viewEmployee.temporary
                                    }
                                    onChange={(e) => {
                                      const value = e.target.checked;
                                      setEditEmployee({ ...editEmployee, temporary: value });
                                      setFormData({ ...formData, Temporary: value, temporary: value });
                                    }}
                                  />
                                  <span className="text-muted">{(isEditMode ? (editEmployee.temporary ?? formData.Temporary) : viewEmployee.temporary) ? 'Yes' : 'No'}</span>
                                </div>
                              </Col></Row>
{/* Access-Management hardening (Round 1, decision D5): the "Set new
                                password" field is gone — HR never sets passwords (the API ignores
                                the field). Employees use "Forgot password"; IT will get a
                                "Send reset e-mail" action in the Account Security tab. */}
                          </Form>
                        </TabPane>

                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <div className="modal-footer">

              {isEditMode ? (
                <div className="modal-footer">
                  <Button color="primary" onClick={tog_togFirst}>Save changes</Button>
                  <Link to="#" className="btn btn-link link-success fw-medium" onClick={tog_togView}><i className="ri-close-line me-1 align-middle"></i> Close</Link>
                </div>
              ) : (
                <div className="modal-footer">
                  <Link to="#" className="btn btn-link link-success fw-medium" onClick={tog_togView}><i className="ri-close-line me-1 align-middle"></i> Close</Link>
                </div>
              )}
            </div>

          </ModalFooter>
        </div>
      </Modal>


      {/* Modal Save changes */}

      <Modal
        isOpen={modal_togFirst}
        toggle={() => {
          tog_togFirst();
        }}
        id="firstmodal"
        centered
      >
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-2'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
              {/* <button className="btn btn-light"><i className="ri-google-fill align-bottom text-danger"></i> Google</button>
              <button className="btn btn-info"><i className="ri-facebook-fill align-bottom"></i> Facebook</button> */}
            </div>
          </ModalBody>
          <ModalBody className="text-center p-5">
            <lord-icon
              src="https://cdn.lordicon.com/tdrtiskw.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#405189"
              style={{ width: "70px", height: "70px" }}>
            </lord-icon>
            <div className="mt-4 pt-4">
              <h4>Are You sure you want Save Changes?</h4>
              <p className="text-muted"> You are changing the Employee basic Details and Send to the Server! Kindly verify before sending. </p>
              <div className="hstack gap-2 justify-content-center">

                <button type="submit" onClick={handleUpdateEmployee} className="btn btn-primary w-50">Yes</button>

                <button type="submit" onClick={tog_togFirst} className="btn btn-danger w-50">No</button>

              </div>

            </div>
          </ModalBody>
        </div>
      </Modal>


      <Modal
        isOpen={modal_togSecond}
        toggle={() => {
          tog_togSecond();
        }}
        id="secondmodal"
        centered
      >
        <ModalHeader>
          <h5 className="modal-title" id="staticBackdropLabel">Success</h5>
        </ModalHeader>
        <ModalBody className="text-center p-5">
          <lord-icon
            src="https://cdn.lordicon.com/lupuorrc.json"
            trigger="loop"
            colors="primary:#121331,secondary:#08a88a"
            style={{ width: "120px", height: "120px" }}>
          </lord-icon>

          <div className="mt-4">
            <h4 className="mb-3">Changes has been Done!</h4>
            <p className="text-muted mb-4">You have successfully change an employee Details. 🎉</p>
            <div className="hstack gap-2 justify-content-center">

              <Button color="light" onClick={() => tog_togSecond(false)}>Close</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>


      {/* <Modal
        isOpen={modal_togSecond}
        toggle={() => {
          tog_togSecond();
        }}
        id="secondmodal"
        centered
      >
        <ModalHeader className="modal-title" id="exampleModalToggleLabel2" toggle={() => {
          tog_togSecond();
        }}>
          Modal 2

        </ModalHeader>
        <ModalBody className="text-center p-5">
          <lord-icon
            src="https://cdn.lordicon.com/zpxybbhl.json"
            trigger="loop"
            colors="primary:#405189,secondary:#0ab39c"
            style={{ width: "150px", height: "150px" }}>
          </lord-icon>
          <div className="mt-4 pt-3">
            <h4 className="mb-3">Changes </h4>
            <p className="text-muted mb-4">Hide this modal and show the first with the button below Automatically Send your invitees a follow -Up email.</p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="danger" onClick={() => { tog_togFirst(); tog_togSecond(false); }}>
                Back to First
              </Button>
              <Button color="light" onClick={() => tog_togSecond(false)}>Close</Button>
            </div>
          </div>
        </ModalBody>

      </Modal> */}

      {/* Modal Save Changes End */}


      {/* Modal Inactive User First */}

      <Modal
        isOpen={modal_togDelete}
        toggle={() => {
          tog_togDelete();
        }}
        id="firstmodal"
        centered
      >
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-2'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
              {/* <button className="btn btn-light"><i className="ri-google-fill align-bottom text-danger"></i> Google</button>
              <button className="btn btn-info"><i className="ri-facebook-fill align-bottom"></i> Facebook</button> */}
            </div>
          </ModalBody>
          <ModalBody className="text-center p-5">
            <lord-icon
              src="https://cdn.lordicon.com/tdrtiskw.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#405189"
              style={{ width: "100px", height: "100px" }}>
            </lord-icon>
            <div className="mt-4 pt-4">
              <h4>Are You sure you want Inactive this Employee?</h4>
              <p className="text-muted"> Employee has been Inactivated. </p>
              <div className="hstack gap-2 justify-content-center">


                <button type="submit" onClick={handleInactiveEmployee} className="btn btn-primary w-50">Yes</button>

                <button type="submit" onClick={tog_togDelete} className="btn btn-danger w-50">No</button>




              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      {/* Modal Inactive User First End */}



      {/* Inactive Employee */}

      <Modal
        isOpen={modal_togDeleteSecond}
        toggle={() => {
          tog_togDeleteSecond();
        }}
        centered
      >
        <ModalHeader className="modal-title" />

        <ModalBody className="text-center p-5">
          <lord-icon src="https://cdn.lordicon.com/hrqwmuhr.json"
            trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "120px", height: "120px" }}>
          </lord-icon>
          <div className="mt-4">
            <h4 className="mb-3">Employee Successfully Inactivated!</h4>
            <p className="text-muted mb-4"> </p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={tog_togDeleteSecond}>Close</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Inactive Employee End */}

    </React.Fragment >
  );
};

const SortingTable = () => {
  const sortingTable =
    [
      { id: "10", name: "Tyrone", email: "tyrone@example.com", designation: "Senior Response Liaison", company: "Raynor, Rolfson and Daugherty", location: "Qatar" },
      { id: "09", name: "Cathy", email: "cathy@example.com", designation: "Customer Data Director", company: "Ebert, Schamberger and Johnston", location: "Mexico" },
      { id: "08", name: "Patsy", email: "patsy@example.com", designation: "Dynamic Assurance Director", company: "Streich Group", location: "Niue" },
      { id: "07", name: "Kerry", email: "kerry@example.com", designation: "Lead Applications Associate", company: "Feeney, Langworth and Tremblay", location: "Niger" },
      { id: "06", name: "Traci", email: "traci@example.com", designation: "Corporate Identity Director", company: "Koelpin - Goldner", location: "Vanuatu" },
      { id: "05", name: "Noel", email: "noel@example.com", designation: "Customer Data Director", company: "Howell - Rippin", location: "Germany" },
      { id: "04", name: "Robert", email: "robert@example.com", designation: "Product Accounts Technician", company: "Hoeger", location: "San Marino" },
      { id: "03", name: "Shannon", email: "shannon@example.com", designation: "Legacy Functionality Associate", company: "Zemlak Group", location: "South Georgia" },
      { id: "02", name: "Harold", email: "harold@example.com", designation: "Forward Creative Coordinator", company: "Metz Inc", location: "Iran" },
      { id: "01", name: "Jonathan", email: "jonathan@example.com", designation: "Senior Implementation Architect", company: "Hauck Inc", location: "Holy See" }
    ]

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Designation",
        accessor: "designation",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Company",
        accessor: "company",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Location",
        accessor: "location",
        disableFilters: true,
        filterable: true,
      }
    ],
    []
  );

  return (
    <React.Fragment >
      <TableContainer
        columns={(columns || [])}
        data={(sortingTable || [])}
        isPagination={true}
        // isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={5}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search Products...'
      />
    </React.Fragment >
  );
};

const LoadingStateTable = () => {

  const [display, setDisplay] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setDisplay(true)
    }, 3000);
  }, [])

  const loadingStateTable =
    [
      { id: "10", name: "Tyrone", email: "tyrone@example.com", designation: "Senior Response Liaison", company: "Raynor, Rolfson and Daugherty", location: "Qatar" },
      { id: "09", name: "Cathy", email: "cathy@example.com", designation: "Customer Data Director", company: "Ebert, Schamberger and Johnston", location: "Mexico" },
      { id: "08", name: "Patsy", email: "patsy@example.com", designation: "Dynamic Assurance Director", company: "Streich Group", location: "Niue" },
      { id: "07", name: "Kerry", email: "kerry@example.com", designation: "Lead Applications Associate", company: "Feeney, Langworth and Tremblay", location: "Niger" },
      { id: "06", name: "Traci", email: "traci@example.com", designation: "Corporate Identity Director", company: "Koelpin - Goldner", location: "Vanuatu" },
      { id: "05", name: "Noel", email: "noel@example.com", designation: "Customer Data Director", company: "Howell - Rippin", location: "Germany" },
      { id: "04", name: "Robert", email: "robert@example.com", designation: "Product Accounts Technician", company: "Hoeger", location: "San Marino" },
      { id: "03", name: "Shannon", email: "shannon@example.com", designation: "Legacy Functionality Associate", company: "Zemlak Group", location: "South Georgia" },
      { id: "02", name: "Harold", email: "harold@example.com", designation: "Forward Creative Coordinator", company: "Metz Inc", location: "Iran" },
      { id: "01", name: "Jonathan", email: "jonathan@example.com", designation: "Senior Implementation Architect", company: "Hauck Inc", location: "Holy See" }
    ]

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Designation",
        accessor: "designation",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Company",
        accessor: "company",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Location",
        accessor: "location",
        disableFilters: true,
        filterable: true,
      }
    ],
    []
  );

  return (
    <React.Fragment >
      {display ? <TableContainer
        columns={(columns || [])}
        data={(loadingStateTable || [])}
        isPagination={true}
        // isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={5}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search Products...'
      /> : <div className="text-center"><Spinner animation="border" variant="primary" /></div>}
    </React.Fragment >
  );
};

const HiddenColumns = () => {
  const sortingTable =
    [
      { id: "10", name: "Tyrone", email: "tyrone@example.com", designation: "Senior Response Liaison", company: "Raynor, Rolfson and Daugherty", location: "Qatar" },
      { id: "09", name: "Cathy", email: "cathy@example.com", designation: "Customer Data Director", company: "Ebert, Schamberger and Johnston", location: "Mexico" },
      { id: "08", name: "Patsy", email: "patsy@example.com", designation: "Dynamic Assurance Director", company: "Streich Group", location: "Niue" },
      { id: "07", name: "Kerry", email: "kerry@example.com", designation: "Lead Applications Associate", company: "Feeney, Langworth and Tremblay", location: "Niger" },
      { id: "06", name: "Traci", email: "traci@example.com", designation: "Corporate Identity Director", company: "Koelpin - Goldner", location: "Vanuatu" },
      { id: "05", name: "Noel", email: "noel@example.com", designation: "Customer Data Director", company: "Howell - Rippin", location: "Germany" },
      { id: "04", name: "Robert", email: "robert@example.com", designation: "Product Accounts Technician", company: "Hoeger", location: "San Marino" },
      { id: "03", name: "Shannon", email: "shannon@example.com", designation: "Legacy Functionality Associate", company: "Zemlak Group", location: "South Georgia" },
      { id: "02", name: "Harold", email: "harold@example.com", designation: "Forward Creative Coordinator", company: "Metz Inc", location: "Iran" },
      { id: "01", name: "Jonathan", email: "jonathan@example.com", designation: "Senior Implementation Architect", company: "Hauck Inc", location: "Holy See" }
    ]

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Designation",
        accessor: "designation",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Company",
        accessor: "company",
        disableFilters: true,
        filterable: true,
      }
    ],
    []
  );

  return (
    <React.Fragment >
      <TableContainer
        columns={(columns || [])}
        data={(sortingTable || [])}
        isPagination={true}
        // isGlobalFilter={false}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={5}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search Products...'
      />
    </React.Fragment >
  );
};



const SearchTableEPO = ({
  data,
  mode = "mine",
  onEdit,
  onView,
  onApprove,
  onVoid,
  onDuplicate,
  onOpenTimeline,
}) => {

  const [viewEmployee, setViewEmployee] = useState({});
  const [activeTab, setActiveTab] = useState("1");

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await api.get("registration/departments");
        setDepartments(res.data);
      } catch (err) {
        console.error("Failed to fetch departments:", err);
      }
    };

    fetchDepartments();
  }, []);

  const [supervisorName, setSupervisorName] = useState("");

  // useEffect(() => {
  //   const fetchSupervisor = async () => {
  //     if (viewEmployee.supervisor) {
  //       try {
  //         const res = await api.get(`registration/supervisor-name/${viewEmployee.supervisor}`);
  //         setSupervisorName(res.data);
  //         console.log("Supervisor Name :", res.data);
  //       } catch (err) {
  //         console.error("Failed to fetch supervisor name:", err);
  //       }
  //     }
  //   };

  //   fetchSupervisor();
  // }, [viewEmployee.supervisor]);
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [searchTable, setSearchTable] = useState(data);
  const [modal_togView, setmodal_togView] = useState('');
  const [empID, setEmpID] = useState(null);
  const [modal_togFirst, setmodal_togFirst] = useState('');
  const [modal_togSecond, setmodal_togSecond] = useState('');
  const [modal_togDelete, setmodal_togDelete] = useState('');
  const [modal_togDeleteSecond, setmodal_togDeleteSecond] = useState('');
  const [editEmployee, setEditEmployee] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  function tog_togView() {
    setmodal_togView(!modal_togView);

    if (modal_togView) {
      setIsEditMode(false);
      setEditEmployee({});
      setViewEmployee({});
    }


  }

  function tog_togFirst() {
    setmodal_togFirst(!modal_togFirst)
  }

  function tog_togSecond() {
    setmodal_togSecond(!modal_togSecond)
  }
  function tog_togDelete() {
    setmodal_togDelete(!modal_togDelete)
  }

  function tog_togDeleteSecond() {
    setmodal_togDeleteSecond(!modal_togDeleteSecond)
  }

  const getImagePath = () => {
    const imagePath = (editEmployee?.imagePath || viewEmployee?.imagePath || "").trim();

    if (imagePath) {
      return `http://www.sswhite.systems:7168${imagePath}`;
    }

    return "http://www.sswhite.systems:7168/uploads/user-dummy-img.jpg";
  };

  const handleView = async (empId) => {
    try {
      const response = await api.get(`registration/get-employee/${empId}`);

      if (response.status === 200) {
        setViewEmployee(response.data);
        tog_togView()
      }
    } catch (error) {
      console.error("Error fetching employee:", error);
    }
  };


  const handleEdit = async (empId) => {
    try {
      const response = await api.get(`registration/get-employee/${empId}`);
      if (response.status === 200) {
        setEditEmployee(response.data);
        setFormData({ ...response.data });
        setEmpID(empId);
        setIsEditMode(true);
        tog_togView();
      }
    } catch (err) {
      console.error("Failed to load employee:", err);
    }
  };

  const getDepartmentName = (id) => {
    const dept = departments.find((d) => d.id === viewEmployee.dept);
    return dept ? dept.description : viewEmployee.dept;
  };

  const handleDelete = async (empId) => {
    tog_togDelete()
  };


  //Update Employee

  const [formData, setFormData] = useState({
    EmpID: 0,

    FirstName: "",
    MI: "",
    LastName: "",
    Street1: "",
    Street2: "",
    City: "",
    State: "",
    Zip: "",
    Country: "",
    Phone: "",
    dob: "",
    EmgContact: "",
    EpoLimit: 0,
    HireDate: "",
    Grade: 0,
    Type: "",
    Rate: 0.0,
    EmpStatus: "",
    ExpenseCode: "",
    Shift: 1,
    Supervisor: "",
    Dept: "",
    Extension: "",
    Email: "",
    WindowsID: "",
    Title: "",
    CompanyCell: "",
    Gender: "",
    password: "",
    FtoOffset: 0,
    RoleId: 0,
    Temporary: false,   // Round 3 (G-42)
  });



  const handleUpdateEmployee = async () => {
    try {
      const payload = {
        ...formData,

      };
      console.log("Submitting payload: ", JSON.stringify(payload, null, 2));
      const response = await api.put(
        `registration/update-employee`,
        payload
      );

      if (response.status === 200) {
        if (response.data?.warning) {
          toast.warning(response.data.warning, { autoClose: 8000 });
        } else {
          toast.success(response.data?.message || "Employee details updated successfully!");
        }
        tog_togSecond();
        tog_togFirst(false);
      } else {
        toast.error("Failed to update employee.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("An error occurred while updating.");
    }
  };
  //Update Employee


  //Inactive Employee
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const handleInactiveEmployee = async () => {
    try {


      const response = await api.put(
        `registration/set-inactive`, {
        EmpID: selectedEmpId
      }

      );

      if (response.status === 200) {
        if (response.data?.warning) {
          toast.warning(response.data.warning, { autoClose: 8000 });
        } else {
          toast.success(response.data?.message || "Employee inactivated successfully!");
        }
        tog_togDeleteSecond();
        tog_togDelete(false);
      } else {
        toast.error("Failed to inactive employee.");
      }
    } catch (error) {
      console.error("Inactive error:", error);
      toast.error("An error occurred while Inactivating.");
    }
  };
  //Inactive Employee end
  useEffect(() => {
    setSearchTable(data);  // Update state when data prop changes
  }, [data]);

  const canEdit = (status) => String(status || "").toUpperCase() === "PENDING" || String(status || "").toUpperCase() === "PENDING_APPROVAL" || String(status || "").toUpperCase() === "DRAFT";;

  const formatYMD = (v) => {
    if (!v) return "";
    if (typeof v === "string") {
      return v.length >= 10 ? v.substring(0, 10) : v;
    }
    if (v instanceof Date && !isNaN(v)) {
      const y = v.getFullYear();
      const m = String(v.getMonth() + 1).padStart(2, "0");
      const d = String(v.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    return String(v);
  };
  const renderActions = (rowData) => {
    const m = (mode || "mine").toLowerCase();

    return (
      <div className="hstack gap-3 fs-15">
        {onView && (
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              onView?.(rowData);
            }}
            className="link-secondary"
            title="View EPO"
          >
            <i className="ri-eye-line" />
          </Link>
        )}

        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            handleTimeline(rowData.epoNumber);
          }}
          className="link-primary"
          title="Approval Timeline"
        >
          <i className="ri-time-line" />
        </Link>
        <Link
          to="#"
          onClick={async (e) => {
            e.preventDefault();
            try {
              await downloadEpoPdf(rowData.epoNumber, api);
            } catch (err) {
              console.error("PDF generation failed:", err);
            }
          }}
          className="link-success"
          title="Download PDF"
        >
          {/* <i className="ri-time-line" /> */}
          <i className="ri-download-cloud-fill" />
        </Link>
        {m === "mine" && (
          <>
            {canEdit(rowData.status) ? (
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  onEdit?.(rowData);
                }}
                className="link-danger"
                title="Edit"
              >
                <i className="ri-settings-3-line" />
              </Link>
            ) : (
              <span className="text-muted" title="Only PENDING EPOs can be edited">
                <i className="ri-settings-3-line" />
              </span>
            )}

            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                onDuplicate?.(rowData);
              }}
              className="link-warning"
              title="Duplicate EPO"
            >
              <i className="ri-file-copy-fill align-bottom" />
            </Link>

            {/* <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                onDelete(rowData);
              }}
              className="link-danger"
              title="Delete"
            >
              <i className="ri-delete-bin-5-line" />
            </Link> */}
          </>
        )}

        {m === "awaiting" && (
          <>
            {onApprove && (
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  onApprove?.(rowData);
                }}
                className="link-success"
                title="Approve"
              >
                <i className="ri-check-line" />
              </Link>
            )}

            {onVoid && (
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  onVoid?.(rowData);
                }}
                className="link-danger"
                title="Void"
              >
                <i className="ri-close-circle-line" />
              </Link>
            )}
          </>
        )}
      </div>
    );
  };




  const columns = useMemo(
    () => [
      {
        Header: "EPO ID",
        accessor: "epoNumber",
        disableFilters: true,
        className: "text-center",
        filterable: false,
      },
      {
        Header: "Purpose",
        accessor: "epoPurpose",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Create Date",
        accessor: "createdDate",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => formatYMD(value),
      },
      {
        Header: "Total",
        accessor: "approxTotal",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center",
        Cell: ({ row }) => renderActions(row.original),
      },
    ],
    [mode, onView, onEdit, onDuplicate, onApprove, onVoid, onOpenTimeline]
  );


  const [timelineOpen, setTimelineOpen] = useState(false);
  const [selectedEpo, setSelectedEpo] = useState(null);
  const navigate = useNavigate();
  const openTimeline = (epoNumber) => {
    navigate(`/epo/${epoNumber}/timeline`);
  };
  const handleTimeline = (epoNumber) => {
    if (onOpenTimeline) return onOpenTimeline(epoNumber);
    return openTimeline(epoNumber);
  };
  const closeTimeline = () => {
    setTimelineOpen(false);
    setSelectedEpo(null);
  };
  return (
    <React.Fragment >
      <TableContainerUser
        columns={(columns || [])}
        data={(searchTable || [])}
        isPagination={true}
        isGlobalFilter={true}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={10}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search EPO...'

      />

      <Modal size="xl" isOpen={modal_togView} toggle={tog_togView}>
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-5'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
            </div>
          </ModalBody>
          <ModalBody>
            <Container fluid>
              <Row>
                <Col xxl={3}>
                  <Card className="mt-n5">
                    <CardBody className="p-4">
                      <div className="card ribbon-box border shadow-none mb-lg-0">
                        <div className="card-body text-center">
                          <div className="ribbon-two ribbon-two-primary">
                            {isEditMode ? (
                              <span>
                                {editEmployee.empID || "Emp.ID"}
                              </span>
                            ) : (
                              <span>
                                {viewEmployee.empID || "Emp.ID"}
                              </span>
                            )}
                          </div>
                          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                            <img src={getImagePath()}
                              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                              alt="user-profile" />
                          </div>
                          {isEditMode ? (
                            <div>
                              <h5 className="fs-16 mb-1">{editEmployee.firstName} {editEmployee.lastName}</h5>
                              <p className="text-muted mb-0">{editEmployee.title}</p>
                            </div>
                          ) : (
                            <div>
                              <h5 className="fs-16 mb-1">{viewEmployee.firstName} {viewEmployee.lastName}</h5>
                              <p className="text-muted mb-0">{viewEmployee.title}</p>
                            </div>
                          )}

                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xxl={9}>
                  <Card className="mt-xxl-n5">
                    <CardHeader>
                      <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                        role="tablist">
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                              tabChange("1");
                            }}>
                            <i className="fas fa-home"></i>
                            Personal Details
                          </NavLink>
                        </NavItem>

                      </Nav>
                    </CardHeader>
                    <CardBody className="p-4">
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                          <Form>
                            <Row>

                              <Col lg={4}>
                                <Label>Firstname</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.firstName || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, firstName: value });
                                      setFormData({ ...formData, firstName: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.firstName || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>

                              <Col lg={4}>
                                <Label>Lastname</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.lastName || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, lastName: value });
                                      setFormData({ ...formData, lastName: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.lastName || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>Title</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.title || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, title: value });
                                      setFormData({ ...formData, title: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.title || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>

                              <Col lg={6}>
                                <Label>Street Address 1</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.street1 || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, street1: value });
                                      setFormData({ ...formData, street1: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.street1 || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>

                              <Col lg={6}>
                                <Label>Street Address 2</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.street2 || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, street2: value });
                                      setFormData({ ...formData, street2: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.street2 || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>

                              <Col lg={6}>
                                <Label>Phone</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.phone || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, phone: value });
                                      setFormData({ ...formData, phone: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.phone || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={3}>
                                <Label>ZIP</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.zip || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, zip: value });
                                      setFormData({ ...formData, zip: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.zip || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={3}>
                                <Label>D.O.B</Label>
                                {isEditMode ? (
                                  <Flatpickr
                                    className="form-control"
                                    value={editEmployee.dateofbirth ? new Date(editEmployee.dateofbirth) : ""}
                                    onChange={(selectedDates) => {
                                      const date = selectedDates[0] || "";
                                      setEditEmployee({ ...editEmployee, dateofbirth: date });
                                      setFormData({ ...formData, dateofbirth: date });
                                    }}
                                    options={{
                                      dateFormat: "Y-m-d",
                                      maxDate: "today"
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={
                                      viewEmployee.dateofbirth
                                        ? new Date(viewEmployee.dateofbirth).toLocaleDateString()
                                        : "N/A"
                                    }
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>City</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.city || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, city: value });
                                      setFormData({ ...formData, city: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.city || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>State</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.state || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, state: value });
                                      setFormData({ ...formData, state: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.state || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>Country</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.country || "USA"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, country: value });
                                      setFormData({ ...formData, country: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.country || "USA"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>Employee Status</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.empStatus || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, empStatus: value });
                                      setFormData({ ...formData, empStatus: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.empStatus || "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              {/* Round 3 (G-42): Temporary / Intern Employee flag — legacy CheckBoxTemp parity.
                                  Bound to formData.temporary so it round-trips to update-employee. */}
                              <Col lg={4}>
                                <Label>Temporary / Intern Employee</Label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 8 }}>
                                  <Input
                                    type="checkbox"
                                    style={{ width: 18, height: 18 }}
                                    disabled={!isEditMode}
                                    checked={
                                      isEditMode
                                        ? !!(editEmployee.temporary ?? formData.Temporary)
                                        : !!viewEmployee.temporary
                                    }
                                    onChange={(e) => {
                                      const value = e.target.checked;
                                      setEditEmployee({ ...editEmployee, temporary: value });
                                      setFormData({ ...formData, Temporary: value, temporary: value });
                                    }}
                                  />
                                  <span className="text-muted">{(isEditMode ? (editEmployee.temporary ?? formData.Temporary) : viewEmployee.temporary) ? 'Yes' : 'No'}</span>
                                </div>
                              </Col>
                              <Col lg={4}>
                                <Label>Rate Type</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={
                                      editEmployee.expenseCode === "IDL"
                                        ? "Salary"
                                        : editEmployee.expenseCode
                                          ? "Hourly"
                                          : ""
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, expenseCode: value });
                                      setFormData({ ...formData, expenseCode: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={
                                      viewEmployee.expenseCode === "IDL"
                                        ? "Salary"
                                        : viewEmployee.expenseCode
                                          ? "Hourly"
                                          : ""
                                    }
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={4}>
                                <Label>Shift Code</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.shift ?? 1}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, shift: value });
                                      setFormData({ ...formData, shift: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.shift ?? 1}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={6}>
                                <Label>Department</Label>
                                {isEditMode ? (
                                  <Input
                                    type="select"
                                    value={editEmployee.dept || "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, dept: value });
                                      setFormData({ ...formData, dept: value });
                                    }}
                                  >
                                    <option value="">Select Department</option>
                                    {departments.map((d) => (
                                      <option key={d.id} value={d.id}>
                                        {d.description}
                                      </option>
                                    ))}
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    value={getDepartmentName(viewEmployee.dept)}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={6}>
                                <Label>Supervisor</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={supervisorName || editEmployee.supervisor}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, supervisor: value });
                                      setFormData({ ...formData, supervisor: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={supervisorName || viewEmployee.supervisor}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={6}>
                                <Label>Email Address</Label>
                                {isEditMode ? (
                                  <Input
                                    type="text"
                                    value={editEmployee.email ?? "N/A"}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, email: value });
                                      setFormData({ ...formData, email: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="text"
                                    value={viewEmployee.email ?? "N/A"}
                                    readOnly
                                  />
                                )}
                              </Col>
                              <Col lg={6}>
                                <Label>Password</Label>
                                {isEditMode ? (
                                  <Input
                                    type="password"
                                    value={editEmployee.password}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setEditEmployee({ ...editEmployee, password: value });
                                      setFormData({ ...formData, password: value });
                                    }}
                                  />
                                ) : (
                                  <Input
                                    type="password"
                                    value={viewEmployee.password}
                                    readOnly
                                  />
                                )}
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>

                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <div className="modal-footer">

              {isEditMode ? (
                <div className="modal-footer">
                  <Button color="primary" onClick={tog_togFirst}>Save changes</Button>
                  <Link to="#" className="btn btn-link link-success fw-medium" onClick={tog_togView}><i className="ri-close-line me-1 align-middle"></i> Close</Link>
                </div>
              ) : (
                <div className="modal-footer">
                  <Link to="#" className="btn btn-link link-success fw-medium" onClick={tog_togView}><i className="ri-close-line me-1 align-middle"></i> Close</Link>
                </div>
              )}
            </div>

          </ModalFooter>
        </div>
      </Modal>


      {/* Modal Save changes */}

      <Modal
        isOpen={modal_togFirst}
        toggle={() => {
          tog_togFirst();
        }}
        id="firstmodal"
        centered
      >
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-2'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
              {/* <button className="btn btn-light"><i className="ri-google-fill align-bottom text-danger"></i> Google</button>
              <button className="btn btn-info"><i className="ri-facebook-fill align-bottom"></i> Facebook</button> */}
            </div>
          </ModalBody>
          <ModalBody className="text-center p-5">
            <lord-icon
              src="https://cdn.lordicon.com/tdrtiskw.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#405189"
              style={{ width: "70px", height: "70px" }}>
            </lord-icon>
            <div className="mt-4 pt-4">
              <h4>Are You sure you want Save Changes?</h4>
              <p className="text-muted"> You are changing the Employee basic Details and Send to the Server! Kindly verify before sending. </p>
              <div className="hstack gap-2 justify-content-center">

                <button type="submit" onClick={handleUpdateEmployee} className="btn btn-primary w-50">Yes</button>

                <button type="submit" onClick={tog_togFirst} className="btn btn-danger w-50">No</button>

              </div>

            </div>
          </ModalBody>
        </div>
      </Modal>


      <Modal
        isOpen={modal_togSecond}
        toggle={() => {
          tog_togSecond();
        }}
        id="secondmodal"
        centered
      >
        <ModalHeader>
          <h5 className="modal-title" id="staticBackdropLabel">Success</h5>
        </ModalHeader>
        <ModalBody className="text-center p-5">
          <lord-icon
            src="https://cdn.lordicon.com/lupuorrc.json"
            trigger="loop"
            colors="primary:#121331,secondary:#08a88a"
            style={{ width: "120px", height: "120px" }}>
          </lord-icon>

          <div className="mt-4">
            <h4 className="mb-3">Changes has been Done!</h4>
            <p className="text-muted mb-4">You have successfully change an employee Details. 🎉</p>
            <div className="hstack gap-2 justify-content-center">

              <Button color="light" onClick={() => tog_togSecond(false)}>Close</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>




      {/* Modal Save Changes End */}


      {/* Modal Inactive User First */}

      <Modal
        isOpen={modal_togDelete}
        toggle={() => {
          tog_togDelete();
        }}
        id="firstmodal"
        centered
      >
        <div className="modal-content border-0 overflow-hidden">
          <ModalBody className='login-modal p-2'>
            <h5 className="text-white fs-20"></h5>
            <p className="text-white-50 mb-4"><Link to="/#" className="text-white"></Link></p>
            <div className="vstack gap-2 justify-content-center">
              {/* <button className="btn btn-light"><i className="ri-google-fill align-bottom text-danger"></i> Google</button>
              <button className="btn btn-info"><i className="ri-facebook-fill align-bottom"></i> Facebook</button> */}
            </div>
          </ModalBody>
          <ModalBody className="text-center p-5">
            <lord-icon
              src="https://cdn.lordicon.com/tdrtiskw.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#405189"
              style={{ width: "100px", height: "100px" }}>
            </lord-icon>
            <div className="mt-4 pt-4">
              <h4>Are You sure you want Inactive this Employee?</h4>
              <p className="text-muted"> Employee has been Inactivated. </p>
              <div className="hstack gap-2 justify-content-center">


                <button type="submit" onClick={handleInactiveEmployee} className="btn btn-primary w-50">Yes</button>

                <button type="submit" onClick={tog_togDelete} className="btn btn-danger w-50">No</button>




              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      {/* Modal Inactive User First End */}



      {/* Inactive Employee */}

      <Modal
        isOpen={modal_togDeleteSecond}
        toggle={() => {
          tog_togDeleteSecond();
        }}
        centered
      >
        <ModalHeader className="modal-title" />

        <ModalBody className="text-center p-5">
          <lord-icon src="https://cdn.lordicon.com/hrqwmuhr.json"
            trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "120px", height: "120px" }}>
          </lord-icon>
          <div className="mt-4">
            <h4 className="mb-3">Employee Successfully Inactivated!</h4>
            <p className="text-muted mb-4"> </p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={tog_togDeleteSecond}>Close</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Inactive Employee End */}

    </React.Fragment >
  );
};


const SearchTableDMS = ({ data, show }) => {

  const [searchTableDms, setSearchTableDms] = useState(data);
  const navigate = useNavigate();
  const [viewOpen, setViewOpen] = useState(false);
  const [viewDmsId, setViewDmsId] = useState(null);
  useEffect(() => {
    setSearchTableDms(data);
    console.log("Log DMSId :", viewDmsId);
  }, [data]);

  // Round DMS-UAT-4 (2026) — audit fix: the email-token landing page
  // (TokenAction.js "View document first") navigates to
  // /document-management?openDmsId=N, but nothing ever read that query
  // param — the link silently landed on the plain list. Honor it here:
  // on mount, if a valid openDmsId is present, open the preview modal
  // for that document once. (The /full fetch inside DmsViewModal still
  // enforces access server-side.)
  useEffect(() => {
    try {
      const raw = new URLSearchParams(window.location.search).get("openDmsId");
      const n = Number(raw);
      if (Number.isFinite(n) && n > 0) {
        setViewDmsId(n);
        setViewOpen(true);
      }
    } catch { /* malformed query — ignore */ }
  }, []);
  const openView = (doc) => {
    console.log("Doc object:", doc);
    setViewDmsId(doc.dmsId);
    setViewOpen(true);
  };

  const closeView = () => {
    setViewOpen(false);
    setViewDmsId(null);
  };
  useEffect(() => {
    console.log("Table data:", data);
  }, [data]);
  const getDocTypeRoute = (docType) => {
    switch (docType) {
      case 1:
        return "sop";
      case 2:
        return "wi";
      case 3:
        return "fcd";
      case 4:
        return "ecn";
      case 5:
        return "lit";
      default:
        return "ecn";
    }
  };
  const approveDocument = async (doc) => {
    try {
      const userName = JSON.parse(sessionStorage.getItem("authUser"))?.uid;

      await api.post(`/dms/${doc.dmsId}/approve`, {
        approverId: Number(userName)
      });
      refreshStoredDmsPdf(doc.dmsId, api);   // Go-live parity (2026-09-24): PDF matches the new status

      toast.success("Document approved successfully");
      //window.location.reload();
    } catch (error) {
      console.error(error);
      toast.error("Failed to approve document");
    }
  };

  const denyDocument = async (doc) => {
    try {
      const userName = JSON.parse(sessionStorage.getItem("authUser"))?.uid;

      await api.post(`/dms/${doc.dmsId}/deny`, {
        approverId: Number(userName)
      });

      toast.success("Document denied successfully");
      //window.location.reload();
    } catch (error) {
      console.error(error);
      toast.error("Failed to deny document");
    }
  };

  // ─── Phase 2.4c — Release workflow ────────────────────────────────────────
  // Surfaced only when the filter chip is "Awaiting Release". Calls
  // POST /api/dms/{id}/release with the current user's empid as releasedBy
  // and the chosen implementation date.
  // -------------------------------------------------------------------------
  const [releaseTarget, setReleaseTarget] = useState(null);
  const [releaseImplDate, setReleaseImplDate] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  });
  const [releasing, setReleasing] = useState(false);

  const openReleaseModal = (doc) => {
    setReleaseTarget(doc);
    const d = new Date();
    setReleaseImplDate(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`);
  };
  const closeReleaseModal = () => {
    if (releasing) return;
    setReleaseTarget(null);
  };

  const releaseDocument = async () => {
    if (!releaseTarget) return;
    setReleasing(true);
    try {
      const userName = JSON.parse(sessionStorage.getItem("authUser"))?.uid;
      await api.post(`/dms/${releaseTarget.dmsId}/release`, {
        releasedBy: Number(userName),
        implementationDate: releaseImplDate || null,
      });
      refreshStoredDmsPdf(releaseTarget.dmsId, api);   // Go-live parity (2026-09-24): PDF matches the released status
      toast.success(`Released ${releaseTarget.docId}`);
      // Optimistic: drop the row from local state so the user sees it disappear
      setSearchTableDms((prev) => prev.filter((r) => r.dmsId !== releaseTarget.dmsId));
      setReleaseTarget(null);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.error || "Failed to release document");
    } finally {
      setReleasing(false);
    }
  };

  const editDocument = (doc) => {
    const routeDocType = getDocTypeRoute(doc.docType);
    navigate(`/dms/edit/${routeDocType}/${doc.dmsId}`);
  };
  const formatYMD = (v) => {
    if (!v) return "";
    if (typeof v === "string") {
      return v.length >= 10 ? v.substring(0, 10) : v;
    }
    if (v instanceof Date && !isNaN(v)) {
      const y = v.getFullYear();
      const m = String(v.getMonth() + 1).padStart(2, "0");
      const d = String(v.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
    return String(v);
  };


  const columns = useMemo(
    () => [
      {
        Header: "Doc ID",
        accessor: "docId",
                className: "text-center",
              },
      {
        Header: "Title",
        accessor: "docTitle",
                      },
      {
        Header: "Rev",
        accessor: "rev",
                
      },
      {
        Header: "Author",
        accessor: "author",
                      },
      {
        Header: "Implementation",
        accessor: "implementationDate",
                        Cell: ({ value }) => formatYMD(value),
      },
      {
        Header: "Created",
        accessor: "createdDate",
                        Cell: ({ value }) => formatYMD(value),
      },
      {
        Header: "Status",
        accessor: "status",
                      },
      {
        Header: "Last Accessed",
        accessor: "lastAccessed",
                        Cell: ({ value }) => formatYMD(value),
      },

      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        disableSortBy: true,
        className: "text-center",
        Cell: ({ row }) => {
          const doc = row.original;
          const isApprovalMode = show === "AwaitingMyApproval";
          const isReleaseMode = show === "AwaitingRelease";

          return (
            <div className="hstack gap-3 fs-15">

              <span
                onClick={(e) => {
                  e.stopPropagation();
                  openView(doc);
                }}
                className="link-primary"
                style={{ cursor: "pointer" }}
                title="View"
              >
                <i className="ri-eye-line"></i>
              </span>

              {isApprovalMode ? (
                <>
                  <span
                    onClick={async (e) => {
                      e.stopPropagation();
                      await approveDocument(doc);
                    }}
                    className="link-success"
                    style={{ cursor: "pointer" }}
                    title="Approve"
                  >
                    <i className="ri-check-line"></i>
                  </span>

                  <span
                    onClick={async (e) => {
                      e.stopPropagation();
                      await denyDocument(doc);
                    }}
                    className="link-danger"
                    style={{ cursor: "pointer" }}
                    title="Deny"
                  >
                    <i className="ri-close-line"></i>
                  </span>
                </>
              ) : isReleaseMode ? (
                // Phase 2.4c — Release action. Opens a modal so the user
                // can confirm + pick the implementation date. The backend
                // verifies the caller has the "Documents Ready for Release"
                // permission, so unauthorized callers get a 400.
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    openReleaseModal(doc);
                  }}
                  className="link-info"
                  style={{ cursor: "pointer" }}
                  title="Release"
                >
                  <i className="ri-send-plane-line"></i>
                </span>
              ) : doc.canEdit === false ? (
                /* Round DMS-Legacy-Parity-8: the pencil follows the ONE edit
                   rule the server computes per row (`canEdit`) — the same rule
                   the document's Edit button and the PUT use: Draft → author;
                   Saved → DMS create access; Pending → manager / author's
                   supervisor; Needs Revision → author / manager / supervisor;
                   every status → Document Control and IT Admin (override).
                   Rows without the flag (older API) keep the pencil. */
                null
              ) : (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    editDocument(doc);
                  }}
                  className="link-success"
                  style={{ cursor: "pointer" }}
                  title="Edit"
                >
                  <i className="ri-pencil-line"></i>
                </span>
              )}
            </div>
          );
        }
      }

    ]

  );

  return (
    <React.Fragment >
      <ToastContainer />
      {/* Round 35 — CSV export of the full loaded document list */}
      <div className="d-flex justify-content-end mb-2">
        <button
          type="button"
          className="btn btn-soft-primary btn-sm"
          onClick={() =>
            exportRowsToCsv("dms-documents.csv", [
              { key: "docId",    label: "Doc ID" },
              { key: "docTitle", label: "Title" },
              { key: "rev",      label: "Rev" },
              { key: "author",   label: "Author" },
              { key: "implementationDate", label: "Implementation" },
              { key: "createdDate",        label: "Created" },
              { key: "status",   label: "Status" },
              { key: "lastAccessed",       label: "Last Accessed" },
            ], searchTableDms)
          }
        >
          <i className="ri-download-2-line align-bottom me-1" />Export CSV ({(searchTableDms || []).length})
        </button>
      </div>
      <TableContainerUser
        columns={columns}
        data={searchTableDms}

        onRowDoubleClick={(row) => openView(row.original)}
        isPagination={true}
        isGlobalFilter={false} /* Round 32 — replaced by the per-column filter row */
        iscustomPageSize={true}
        className="custom-header-css table align-middle table-nowrap"
        tableClassName="table-centered align-middle table-nowrap mb-0"
        theadClassName="text-muted table-light"
        SearchPlaceholder='Search Documents'
        /* ──────────────────────────────────────────────────────────────
           Hotfix 11 — Custom DMS global filter.

           Why a custom one: every DMS column above is `disableFilters:
           true`, which in react-table v7 ALSO sets canFilter=false on
           those columns. The default useGlobalFilter only walks
           filterable columns, so with everything disabled, the search
           box had nothing to scan — that's the "very weak search"
           symptom the user observed.

           Below is column-agnostic: walks each row's raw `original`
           object and substring-matches the search term (case-
           insensitive, null-tolerant) against the meaningful fields:
             docId           — "WI-17163", "ECN-20323"
             docTitle        — title text
             author          — author name
             status          — "Released", "Pending Approval", etc.
             docType         — "ECN" / "WI" / "SOP" / "FCD" / "LIT"
             rev             — revision number
             implementationDate / createdDate — date strings
             country         — country code

           Works across the entire filtered dataset (whichever Show
           filter is active), so the user's "if i put all, it should
           check all docs" expectation is honored.
           ────────────────────────────────────────────────────────────── */
        globalFilterFn={React.useCallback((rows, _columnIds, filterValue) => {
          if (!filterValue) return rows;
          const search = String(filterValue).toLowerCase().trim();
          if (!search) return rows;
          return rows.filter((row) => {
            const v = row.original || {};
            const fields = [
              v.docId, v.docTitle, v.author, v.status,
              v.docType, v.rev, v.dmsId,
              v.implementationDate, v.createdDate, v.lastAccessed,
              v.country,
            ];
            return fields.some(
              (f) => f != null && String(f).toLowerCase().includes(search)
            );
          });
        }, [])}
      />

      <DmsViewModal
        isOpen={viewOpen}
        toggle={closeView}
        dmsId={viewDmsId}
      />

      {/* Phase 2.4c — Release confirm modal. Shown only when a user clicks
          the release icon from the Awaiting Release filter. */}
      <Modal isOpen={!!releaseTarget} toggle={closeReleaseModal} backdrop={releasing ? "static" : true}>
        <ModalHeader toggle={closeReleaseModal}>Release document</ModalHeader>
        <ModalBody>
          {releaseTarget && (
            <>
              <p>
                Releasing <code>{releaseTarget.docId}</code> — <strong>{releaseTarget.docTitle}</strong>.
                <br />
                This sets the document to "Approved &amp; Released" and stamps the implementation date.
              </p>
              <div className="mb-2">
                <Label for="releaseImplDate">Implementation Date</Label>
                <Input
                  type="date"
                  id="releaseImplDate"
                  value={releaseImplDate}
                  onChange={(e) => setReleaseImplDate(e.target.value)}
                  disabled={releasing}
                />
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={closeReleaseModal} disabled={releasing}>Cancel</Button>
          <Button color="success" onClick={releaseDocument} disabled={releasing || !releaseImplDate}>
            {releasing ? (<><Spinner size="sm" /> Releasing…</>) : "Release"}
          </Button>
        </ModalFooter>
      </Modal>

    </React.Fragment >
  );
};


export { DefaultTable, PaginationTable, SearchTable, SearchTableEdit, SearchTableEPO, SearchTableDMS, SortingTable, LoadingStateTable, HiddenColumns };
